// ============================================================================
// Utility — Visite e Contratti (dati caricati da Supabase: dipendenti_scheda)
// ============================================================================

export const COLONNE_VISITE = [
  "N.", "DIPENDENTE", "FORM. GEN 5a", "FORM. SPEC 5a",
  "INC/EMERG. 3a", "1° SOCC. 3a", "PIATTAF 5a", "RLS 1a",
  "ESCAV", "GRU", "LAV QUOTA 5a", "PREPOSTO 2a",
  "VISITE", "DATA ASSUNZIONE", "SCAD. CONTRATTO", "SCAD. PDS", "NOTE"
];

// Converte DD/MM/YYYY → Date per confronti
export function parseDate(str) {
  if (!str || str.includes("*") || str === "INDET." || str === "CESSATO" || str === "ILLIMITATO" || str === "illimitato") return null;
  const parts = str.split("/");
  if (parts.length !== 3) return null;
  return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
}

// Ritorna colore stato scadenza
export function scadenzaColor(str) {
  const d = parseDate(str);
  if (!d) return null;
  const today = new Date();
  const diff = (d - today) / (1000 * 60 * 60 * 24);
  if (diff < 0) return { bg: "rgba(239,68,68,0.12)", text: "#ef4444" };   // scaduta
  if (diff < 90) return { bg: "rgba(245,158,11,0.12)", text: "#f59e0b" }; // < 3 mesi
  return null;
}
